import { ReactNode } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

interface PassengerFormShellProps {
  title: ReactNode;
  columnHeaders?: ReactNode;
  children: ReactNode;
  addButton: ReactNode;
  /** Optional offer info text, shown below the add control. */
  infoText?: ReactNode;
}

/**
 * Shared outer layout for rail passenger forms (title, optional desktop headers, rows, add control, info text).
 * Provider forms keep ownership of fields and Redux wiring.
 */
export default function PassengerFormShell({
  title,
  columnHeaders,
  children,
  addButton,
  infoText
}: PassengerFormShellProps) {
  return (
    <Box sx={{ display: "flex" }} pb={3} pt={{ xs: 5, sm: 3 }}>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "center"
        }}
      >
        <Box className="passengers-title" pb={2}>
          {title}
        </Box>
        {columnHeaders}
        {children}
        {addButton}
        {infoText && (
          <Box
            mt={2}
            sx={{
              fontFamily: "Neutraface2Italic",
              fontSize: "14px",
              textAlign: "left",
              "& p": { margin: 0, fontSize: "inherit" },
              "& p + p": { marginTop: "8px" }
            }}
          >
            {infoText}
          </Box>
        )}
      </Grid>
    </Box>
  );
}
